export default {
    emits: [
        'success'
    ],
    props: {
        apiObj: {
            type: Object,
            default: ()=>{}
        },
        data: {
            type: Object,
            default: ()=>{}
        },
        accept: {
            type: String,
            default: ".xls, .xlsx"
        },
        maxSize: {
            type: Number,
            default: 10
        },
        tip: {
            type: String,
            default: ""
        },
        tipName: {
            type: String,
            default: "拉黑用户模板.xls"
        },
        buttonName: {
            type: String,
            default: "导入"
        },
        templateUrl: {
            type: String,
            default: ""
        },
        dialogTitle: {
            type: String,
            default: "导入"
        },
        importType: {
            type: Number,
            default: 1
        }
    },
    data () {
        return {
            dialog: false,
            loading: false,
            percentage: 0,
            formData: {}
        };
    },
    mounted () {},
    methods: {
        async handleimportTemplate () {
            let { data } = await this.$API.user.black.template.get(this.queryInfo);
            const link = document.createElement('a');
            link.href = data.import_user;
            link.setAttribute('download', `导入模板.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        open () {
            this.dialog = true;
            this.formData = {};
        },
        close () {
            this.dialog = false;
        },
        before (file) {
            const maxSize = file.size / 1024 / 1024 < this.maxSize;
            if (!maxSize) {
                this.$message.warning(`上传文件大小不能超过 ${this.maxSize}MB!`);
                return false;
            }
            this.loading = true;
        },
        progress (e) {
            this.percentage = e.percent;
        },
        success (res, file) {
            this.$refs.uploader.handleRemove(file);
            this.$refs.uploader.clearFiles();
            this.loading = false;
            this.percentage = 0;
            console.log('importType', this.importType);
            if (this.importType == 1) {
                this.importBlack(res.data);
            } else if (this.importType == 2) {
                this.importIgnoredRemove(res.data);
            } else if (this.importType == 3) {
                this.importIgnored(res.data);
            }
        },
        // 黑名单导入
        async importBlack (file) {
            let obj = {
                url: file,
                type: 1
            };
            let res = await this.$API.user.black.importFile.post(obj);
            if (res?.code === 1) {
                this.$message.success('导入成功');
                setTimeout(()=>{
                    this.close();
                    this.$emit('success');
                }, 500);
            }
        },
        // 免打扰导入
        async importIgnored (file) {
            let obj = {
                url: file,
                type: 1
            };
            let res = await this.$API.user.ignored.importFile.post(obj);
            if (res?.code === 1) {
                this.$message.success('导入成功');
                setTimeout(()=>{
                    this.close();
                    this.$emit('success');
                }, 500);
            }
        },
        // 剔除免打扰导入
        async importIgnoredRemove (file) {
            let obj = {
                url: file,
                type: 2
            };
            let res = await this.$API.user.ignored.importFile.post(obj);
            if (res?.code === 1) {
                this.$message.success('导入成功');
                setTimeout(()=>{
                    this.close();
                    this.$emit('success');
                }, 500);
            }
        },
        error (err) {
            this.loading = false;
            this.percentage = 0;
            this.$notify.error({
                title: '上传文件未成功',
                message: err
            });
        },
        request (param) {
            Object.assign(param.data, this.formData);
            const data = new FormData();
            data.append(param.filename, param.file);
            for(const key in param.data){
                data.append(key, param.data[key]);
            }
            this.apiObj.post(data, {
                onUploadProgress: (e)=>{
                    const complete = parseInt(e.loaded / e.total * 100 | 0, 10);
                    param.onProgress({
                        percent: complete
                    });
                }
            }).then((res)=>{
                param.onSuccess(res);
            }).catch((err)=>{
                param.onError(err);
            });
        }
    }
};
